import React from "react";

import "./style.scss";
import Helmet from "./common/helmet";
import SubMenu from "./common/submenu";
import Verano2019Layout from "./layouts/verano2019/verano2019Layout";
import Footer from "./common/footer";
import NavBar from "./common/navbar";

const Layout = ({ children }) => (
  <div>
    <Helmet />
    <SubMenu />
    <NavBar />
    <Verano2019Layout />
    <Footer />
  </div>
);

export default Layout;
